import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import angleLeft from "../../../assets/images/icons/angle-left.svg";
import angleRight from "../../../assets/images/icons/angle-right.svg";
import sortAscIcon from "../../../assets/images/icons/sort-asc.svg";
import sortDescIcon from "../../../assets/images/icons/sort-desc.svg";
import { getShortContent, translateToString } from "../../../utils/commonFunctions";
import { deleteResourceAction, getResourceListAction } from "../dashboard/actions";
import "./style.scss";
import DeleteModel from "../pages/membership/deleteModel";

function ResourceList(props) {
  const [search, setSearch] = useState("");
  const [shot, setShot] = useState(25);
  const [selected, setSelected] = useState(0);
  const [sortOrder, setSortOrder] = useState("display_type_asc");

  const handleChange = (value) => {
    setSelected(value.selected);
    props.getResourceListAction(`order=${sortOrder}&paginate=${shot}&page=${value.selected + 1}`);
    handleClickTop();
  };

  const changeSortOrder = () => {
    if (sortOrder === "display_type_asc") {
      setSortOrder("display_type_desc");
    } else {
      setSortOrder("display_type_asc");
    }
  };

  useEffect(() => {
    props.getResourceListAction(`order=${sortOrder}&paginate=${shot}`);
  }, [sortOrder]);

  const handleClickTop = () => {
    window.scrollTo(0, 0);
  };

  const handleChangeSearch = (e) => {
    setSearch(e.target.value);
    props.getResourceListAction(`order=${sortOrder}&search=${e.target.value}`);
  };

  const handleChangePaginate = (e) => {
    setShot(e.target.value);
    props.getResourceListAction(`order=${sortOrder}&paginate=${e.target.value}`);
    handleClickTop();
  };

  const deleteResponseHandler = (id) => {
    props.deleteResourceAction(id);
  };

  return (
    <div className="blackListArea">
      <div className="adminContainer">
        <div className="d-flex flex-wrap align-items-center justify-content-between titleBoxWrap">
          <h2 className="adminSectionTitle">Resources</h2>
          <div className="d-flex flex-wrap align-items-center">
            <Link to="/admin/categories" className="btn btn-darkblue">
              Categories
            </Link>
            <Link to="/admin/add-new-resource" className="btn btn-green ms-3">
              Add New Resources
            </Link>
          </div>
        </div>
        <Row className="align-items-center justify-content-between searchBoxWrap">
          <Col xs={4}>
            <div className="position-relative">
              <input
                type="text"
                className="pe-4 form-control pe-4"
                value={search}
                onChange={handleChangeSearch}
                placeholder="Search by Resource Name or Category"
              />
              <i className="fa-regular fa-magnifying-glass position-absolute top-50 end-0 translate-middle-y" />
            </div>
          </Col>
          <Col xs="auto">
            {props.resources_list?.total > 0 && (
              <div className="shortingFilter">
                <select value={shot} onChange={handleChangePaginate}>
                  <option value="5">Showing 5</option>
                  <option value="10">Showing 10</option>
                  <option value="25">Showing 25</option>
                  <option value="50">Showing 50</option>
                </select>
                <span>out of {props.resources_list?.total}</span>
              </div>
            )}
          </Col>
        </Row>
        <div className="tableResponsive">
          <table className="tableStyle">
            <thead>
              <tr>
                <th>RESOURCE NAME</th>
                <th>STATUS</th>
                <th>TYPE</th>
                <th>CATEGORIES</th>
                <th className="sort-icon-column" onClick={changeSortOrder}>
                  DISPLAY TYPE
                  {sortOrder === "display_type_asc" ? (
                    <img className="sort-icon" src={sortAscIcon} alt="SORT ASC" />
                  ) : (
                    <img className="sort-icon" src={sortDescIcon} alt="SORT DESC" />
                  )}
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {props.resources_list?.data?.map((item) => (
                <tr key={item.id}>
                  <td>
                    <strong>
                      <Link to={`/resources/${item.id}/${item.url?.toLowerCase()}`}>{getShortContent(item?.name)}</Link>
                    </strong>
                  </td>
                  <td>{(item.status === "Draft" && "Draft") || (item.status === "Publish" && "Published") || (item.status === "Later" && "Later")}</td>
                  <td>
                    {(item.resource_type === "how_to_guides" && "How To Guides") ||
                      (item.resource_type === "spreadsheets" && "Spreadsheets") ||
                      (item.resource_type === "calculators_tools" && "Calculators + Tools") ||
                      (item.resource_type === "videos" && "How To Guides") ||
                      (item.resource_type === "audio-program" && "Audio Program") ||
                      (item.resource_type === "forms" && "Forms") ||
                      (item.resource_type === "checklists" && "Checklists")}
                  </td>
                  <td>
                    {" "}
                    {item.categories?.split(",").map((item) => (
                      <span className="category" key={item}>
                        {item} <span className="comma">,</span>
                      </span>
                    ))}
                  </td>
                  <td>{item.display_type}</td>
                  <td className="text-right">
                    <div className="d-flex">
                      {item.status !== "Draft" ? (
                        <Link to={`/resources/${item.id}/${item.url?.toLowerCase()}`}>
                          <i className="text-darkblue fa-regular fa-arrow-up-right-from-square me-2" />
                        </Link>
                      ) : null}
                      <Link to={`/admin/resources/${item.id}/${translateToString(item.name?.toLowerCase())}`}>
                        <i className="text-darkblue fa-regular fa-pen-to-square me-2" />
                      </Link>
                      <DeleteModel onClick={() => deleteResponseHandler(item.id)} listItem />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          {props.resources_list?.total > props.resources_list?.per_page && (
            <ReactPaginate
              containerClassName="paginationWrapper"
              pageCount={props.resources_list.total / props.resources_list.per_page}
              pageRangeDisplayed={props.resources_list.per_page}
              onPageChange={handleChange}
              nextLabel={<img src={angleRight} alt="right" />}
              previousLabel={<img src={angleLeft} alt="left" />}
              forcePage={selected}
            />
          )}
          <div className="shortingFilter">
            <select value={shot} onChange={handleChangePaginate}>
              <option value="5">Showing 5</option>
              <option value="10">Showing 10</option>
              <option value="25">Showing 25</option>
              <option value="50">Showing 50</option>
            </select>
            <span>out of {props.resources_list?.total}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  resources_list: state.admin.resources_list,
});

export default connect(mapStateToProps, {
  getResourceListAction,
  deleteResourceAction,
})(ResourceList);
